import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMember } from '@core/model';

@Injectable({
  providedIn: 'root',
})
export class ApplicationStateService {
  tenantId: string | null = null;
  member$ = new BehaviorSubject<IMember>(null);

  get memberId(): string {
    return this.member$.value?.memberDTO?.memberId;
  }

  get isMCDLineOfBusiness(): boolean {
    return this.member$.value?.memberDetailsDTO.memberBenefit.lineOfBusinessApplicationKey === 'Medicaid';
  }

  setTenantId(tenantId: string): void {
    this.tenantId = tenantId;
  }

  setMember(member: IMember): void {
    this.member$.next(member);
  }
}
